<script>
export default {
  name: 'VerticalMenuSubItem',
  components: {
    Icon: () => import('@/components/general/Icon')
  },

  props: {
    text: {
      type: String,
      default: ''
    },

    link: {
      type: String,
      default: '#'
    },

    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <li class="submenu-item">
    <RouterLink
      :to="link"
      class="menu-link"
      exact
    >
      <Icon
        :name="icon"
        wrapper
        size="medium"
      />
      <span class="text">{{ $t(text) }}</span>
    </RouterLink>
  </li>
</template>
